import CircularProgress from '@mui/material/CircularProgress'
import { useEffect, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useDispatch } from 'react-redux'
import CustomisedButton from '../../../../components/button/button'
import CustomisedCardLine from '../../../../components/card/cardLine'
import CustomizedRange from '../../../../components/slider/range/Range'
import ElementTitle from '../../../../components/title/elementTitle/elementTitle'
import { SALE_ID } from '../../../../config/cacheKey'
import { IConvertToAssetResponse, IGetExchangeRateResponse } from '../../../../models/trade.model'
import { changeRouteType, getpervInnerState } from '../../../../redux/handleBackBtn/handleBackBtnSlice'
import { setHeaderTitle } from '../../../../redux/headerTitle/headerTitleSlice'
import { ConvertToAsset, GetExchangeRate } from '../../../../services/trade.service'
import { ITradeProps } from './ITrade'
import CustomisedCardBullet from '../../../../components/card/cardBullet'


export default function Trade({ setState, selectedTotalCreditForAsset }: ITradeProps) {

    const [selectedAmount, setSelectedAmount] = useState(0);
    const [exchangeRate, setExchangeRate] = useState(0);
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const randomKeyForDispatch = Math.random();
    const { mutate: ConvertToAssetMutate } = useMutation(
        ConvertToAsset,
        {
            onSuccess: (data: IConvertToAssetResponse) => {
                if (data) {
                    queryClient.setQueryData(SALE_ID, data.saleId);
                    setState('tradeHistory')
                }
            },

            onError: () => { },
        }
    );
    const { mutate: GetExchangeRateMutate, isLoading } = useMutation(
        GetExchangeRate,
        {
            onSuccess: (data: IGetExchangeRateResponse) => {

                if (data) {
                    setExchangeRate(data.exchangeRate)
                }
            },

            onError: () => { },
        }
    );

    useEffect(() => {
        dispatch(setHeaderTitle({ color: 'var(--header-color)', header: 'تبدیل دارایی', parentRoute: 'trade' }));
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: `tradeProfile ${randomKeyForDispatch}` }));

        let cancelled = false;
        let timeoutId: any = null;

        const BASE_DELAY = 30000;
        const MAX_DELAY = 1200000;
        let delay = BASE_DELAY;

        const poll = async () => {
            if (cancelled) return;

            if (document.visibilityState !== "visible") {
                timeoutId = setTimeout(poll, BASE_DELAY);
                return;
            }

            try {
                if (selectedTotalCreditForAsset) {
                    await GetExchangeRateMutate({
                        asset: selectedTotalCreditForAsset?.asset,
                        exchange: selectedTotalCreditForAsset?.exchange
                    });
                    delay = BASE_DELAY;
                }
            } catch {
                delay = Math.min(delay * 2, MAX_DELAY);
            }

            timeoutId = setTimeout(poll, delay);
        };

        poll();

        return () => {
            cancelled = true;
            clearTimeout(timeoutId);
        };
    }, [selectedTotalCreditForAsset]);

    const handleConvert = () => {
        ConvertToAssetMutate({
            asset: selectedTotalCreditForAsset?.asset!,
            exchange: selectedTotalCreditForAsset?.exchange!,
            amount: selectedTotalCreditForAsset?.mortgageType === 'NoMortgage' ? selectedAmount : undefined,
            mortgageType: selectedTotalCreditForAsset?.mortgageType
        })
    }

    const rateValue = isLoading ? <div>
        <CircularProgress sx={{ color: "#BBA57A" }} size={12} /> ریال
    </div> : exchangeRate?.toLocaleString() + " ریال";

    useEffect(() => {
        if (
            selectedTotalCreditForAsset?.minimumAmountRial &&
            selectedAmount === 0
        ) {
            setSelectedAmount(selectedTotalCreditForAsset.minimumAmountRial);
        }
    }, [selectedTotalCreditForAsset]);

    return (
        <div className='h-[calc(100svh-60px)] px-5 pt-4 pb-[60px] overflow-y-auto relative'>
            <div className='flex flex-col gap-5'>
                <ElementTitle title={selectedTotalCreditForAsset?.title || ''} />
                <CustomisedCardLine itemList={[{ title: 'موجودی کیف قابل تبدیل', value: `${selectedTotalCreditForAsset?.totalAmountInRials.toLocaleString()} ریال` }]} />
                {
                    selectedTotalCreditForAsset?.showAmountSelector && selectedTotalCreditForAsset?.maximumAmountRial !== 0 &&
                    <>
                        <CustomizedRange
                            selectedAmount={selectedAmount}
                            title={'انتخاب مبلغ برای تبدیل'}
                            setSelectedAmount={setSelectedAmount}
                            minAmount={selectedTotalCreditForAsset?.minimumAmountRial}
                            maxAmount={selectedTotalCreditForAsset?.maximumAmountRial}
                            defaultValue={selectedTotalCreditForAsset?.minimumAmountRial}
                            enableMode={true}
                            amountStep={100_000}
                        ></CustomizedRange>
                    </>
                }
                <CustomisedCardLine itemList={[{ title: 'نرخ تبدیل هر گرم', value: rateValue }]} />
            </div>
            <div className='flex flex-col gap-10 mt-10'>
                <CustomisedButton title={selectedTotalCreditForAsset?.exchangeCommandTitle || ''} disable={false} onClick={() => handleConvert()} type={undefined} />
                <div className='flex flex-col gap-3'>
                    {selectedTotalCreditForAsset?.terms?.map((hint, index: number) => (
                        <div key={index} className="w-full h-fit" >
                            <CustomisedCardBullet
                                firstTitle={hint}
                                key={index}
                            />
                        </div>
                    ))}
                </div>
                <div >
                    <img className='block mx-auto w-[70px] h-[70px] p-1 rounded-full  border-[#FFCE0A] border-2' src={selectedTotalCreditForAsset?.logoUrl} alt={selectedTotalCreditForAsset?.title} />
                </div>
            </div>
        </div>
    )
}
